module.exports = __webpack_public_path__ + "static/media/1POLICY1.fc5fb49a.jpg";